import {
  Component,
  OnInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { DataService } from "./data.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import { WidgetConfig } from "../../../class/widget-config";
import { GenericUtils } from './../../../utilities/generic-utils';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiUrlConstant } from "../../../../shared/constants/api-url.constant";
import * as moment from "moment";
addMore(Highcharts);

@Component({
  selector: 'widget-line-chart-with-controls',
  templateUrl: './widget-line-chart-with-controls.component.html',
  styleUrls: ['./widget-line-chart-with-controls.component.scss']
})
export class WidgetLineChartWithControlsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() FILTERS;
  @Input() WIDGETCONFIG: WidgetConfig;
  @Input() CHARTCONFIG;

  highcharts: typeof Highcharts = Highcharts;
  chartOptions: any;

  interval = "";
  errorMessage = "";
  mockChart = null;
  loadingChart = true;
  errorLoadingChart = false;
  timeButtons = [];
  apiSetIndex = 0;
  // [
  //   { name: 'OVERALL_STATUS.HOURLY', selected: false, api: this.apiUrl.OVERVIEW_HOURLY, defaultShow: true, interval: 'hour' },
  //   { name: 'OVERALL_STATUS.DAILY', selected: false, api: this.apiUrl.OVERVIEW_DAILY, defaultShow: true, interval: 'day' },
  //   { name: 'OVERALL_STATUS.WEEKLY', selected: false, api: this.apiUrl.OVERVIEW_WEEKLY, defaultShow: true, interval: 'week' },
  //   { name: 'OVERALL_STATUS.MONTHLY', selected: false, api: this.apiUrl.OVERVIEW_MONTHLY, defaultShow: true, interval: 'month' }
  // ];
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private translateService: TranslateService,
    private dataService: DataService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService,
    private genericUtils: GenericUtils,
    private apiUrl: ApiUrlConstant
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    this.chartOptions = this.genericUtils.deepCopyFunction(this.CHARTCONFIG[0]);
    if (!this.WIDGETCONFIG.api) {
      this.createTimeButtons(this.WIDGETCONFIG.config['apis']);
      const dateTypeData = this.getdate();
      this.getAPIToCall(dateTypeData);
    } else {
      this.getData();
    }

  }

  ngOnInit() {
    this.translateService
      .get("PERFORMANCE.TRANSFER.REASON_FOR_FAILURE")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.WIDGETCONFIG.title = this.WIDGETCONFIG.title || text;
      });
    this.broadcaster.listen("PAGE_WIDGET_DATA").pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.setWidgetData();
    });
  }
  setWidgetData() {
    if (!this.CHARTCONFIG[0].noTarget) {
      const pageData = this.localStorageService.getItem("PAGE_WIDGET_DATA");
      if (pageData) {
        pageData.forEach(element => {
          if (element.widget_id === this.WIDGETCONFIG.id) {
            this.setTarget(element.target);
          }
        });
      }
    }

  }

  setTarget(t) {
    if (this.chartOptions && !this.loadingChart) {
      this.chartOptions.series[2].data = [];
      for (let i = 0; i < this.chartOptions.series[0].data.length; i++) {
        this.chartOptions.series[2].data.push(t);
      }
    }
  }
  createTimeButtons(apiObject) {
    this.timeButtons = [];
    apiObject['apiUrls'][this.apiSetIndex].map((api, index) => {
      const timeButton = {
        name: apiObject['apiNames'][index],
        selected: false,
        api: api,
        defaultShow: true,
        interval: apiObject['apiKeys'][index]
      };
      this.timeButtons.push(timeButton);
    });

  }

  getData() {
    this.errorMessage = "";
    this.mockChart = null;
    this.loadingChart = true;
    this.errorLoadingChart = false;
    const queryParams = { ...this.FILTERS, 'interval_type': this.interval };
    this.dataService
      .getData(this.WIDGETCONFIG.api, this.WIDGETCONFIG, queryParams)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          this.loadingChart = false;

          if (chartData) {
            this.chartOptions = this.dataService.createChart(
              chartData,
              this.CHARTCONFIG
            );
            this.setWidgetData();
          } else {
            this.handleError("ERROR_MSG.NO_DATA");
          }
          this.loadingChart = false;

        },
        error => {
          this.loadingChart = false;
          this.handleError("ERROR_MSG.NO_DATA");
        }
      );
  }

  handleError(message) {
    this.errorLoadingChart = true;
    this.errorMessage = message;
    this.mockChart = [{ chart: this.genericUtils.deepCopyFunction(this.CHARTCONFIG[0]), width: 12 }];

  }

  getAPIToCall(data) {
    this.timeButtons.forEach(ele => {
      ele.name === data ? (ele.selected = true,
        this.WIDGETCONFIG.api = ele.api,
        this.interval = ele.interval) : ele.selected = false;
    });
    this.getData();
    this.WIDGETCONFIG.api = '';
  }

  getdate() {
    const datesArray = this.getDateFilterName();
    const startDate = new Date(this.FILTERS[datesArray[0]]),
      endDate = new Date(this.FILTERS[datesArray[1]]);

    const miliSecond = endDate.getTime() - startDate.getTime();

    //For one Day
    if (miliSecond === 86399000) {
      this.timeButtons.forEach(ele => {
        ele.defaultShow = false;
      });
      return this.timeButtons[0].name;
    }
    //For 1-3 days
    else if (miliSecond > 86399000 && miliSecond < 259199001) {
      this.timeButtons.forEach(ele => {
        (ele.interval === 'hour' || ele.interval === 'day') ? ele.defaultShow = true : ele.defaultShow = false;
      });
      return this.timeButtons[0].name;
    }
    //For upto 14 days
    else if (miliSecond > 259199000 && miliSecond < 1209599001) {
      this.timeButtons.forEach(ele => {
        (ele.interval === 'week' || ele.interval === 'day') ? ele.defaultShow = true : ele.defaultShow = false;
      });
      return this.timeButtons[0].name;
    }
    //For upto 31 days
    else if (miliSecond > 1209599000 && miliSecond < 2678399001) {
      this.timeButtons.forEach(ele => {
        (ele.interval === 'week' || ele.interval === 'day') ? ele.defaultShow = true : ele.defaultShow = false;
      });
      return this.timeButtons[0].name;
    }
    else {
      this.timeButtons.forEach(ele => {
        (ele.interval === 'week'
          || ele.interval === 'day'
          || ele.interval === 'month') ? ele.defaultShow = true : ele.defaultShow = false;
      });
      return this.timeButtons[1].name;
    }


  }

  getDateFilterName() {
    const filterNames = Object.keys(this.FILTERS);
    const datesArray = ["", ""];

    for (let i = 0; i < filterNames.length; i++) {
      if (filterNames[i].indexOf('start') > -1) {
        datesArray[0] = filterNames[i];
      }
      if (filterNames[i].indexOf('end') > -1) {
        datesArray[1] = filterNames[i];
      }

      if (datesArray[0] !== "" && datesArray[1] !== "") break;
    }

    return datesArray;

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
